import type { GameMeta } from '@gmp/game-sdk';

export const orbHavocMeta = {
  id: 'orb-havoc',
  name: 'Orb Havoc',
  tagline: 'Spherical robot vehicles fight over a glowing energy core.',
  description:
    'Steer a weighty energy orb around one of five arenas: Flux Foundry, Moat Keep (the core on an island in a pit), Twin Forges (two platforms over a chasm), the Gauntlet maze or the spinning Turntable. Roll through the core to grab it, keep moving to score, and slam rivals to knock it loose. Everyone drafts a skill, a passive and one arena piece first.',
  minPlayers: 2,
  maxPlayers: 8,
  estimatedMinutes: [3, 5],
  usesMedia: false,
  modes: [{ id: 'crown', name: 'Crown Control', description: 'Hold the core while moving to score. First to the target, or most after the timer.' }],
  theme: { primary: '#7cf2ff', secondary: '#ff7a59', background: '#08121c', ink: '#eafdff' },
  readiness: 'beta',
  genre: 'Physics arena',
  controls: 'touch-action',
  category: 'versus',
  instructions: [
    { icon: 'Sparkles', title: 'Draft', body: 'Pick a skill, a passive and one arena piece to place in a slot. Everything is revealed before the match.' },
    { icon: 'Hand', title: 'Roll', body: 'Drag the stick to roll. Boost for a burst. Your skill has its own button.' },
    { icon: 'Trophy', title: 'Hold the core', body: 'Roll through the glowing core to grab it. You score while carrying it and moving.' },
    { icon: 'Siren', title: 'Knock it loose', body: 'Hit the carrier hard enough and the core pops free. Stuck? Tap Recover to return to your ramp.' },
    { icon: 'Target', title: 'Mind the arena', body: 'Each match has its own arena. Roll into a pit and you start again from your ramp (a carried core goes back to the middle); goo slows you, posts bounce you, a turntable carries you round.' },
  ],
} satisfies GameMeta;
